// src/components/common/UserAvatar/UserAvatar.js
import React from 'react';
import { Avatar } from '@mui/material';

const AVATAR_COLORS = [
  '#4F46E5', '#7C3AED', '#0D9488', '#059669',
  '#DC2626', '#D97706', '#2563EB', '#DB2777',
];

function getAvatarBg(email) {
  if (!email) return '#222222';
  let hash = 0;
  for (let i = 0; i < email.length; i++) {
    hash = email.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export default function UserAvatar({ email, size = 32, onClick, sx = {} }) {
  const initial = email ? email.charAt(0).toUpperCase() : '?';
  const bg = getAvatarBg(email);

  return (
    <Avatar
      onClick={onClick}
      sx={{
        width: size,
        height: size,
        backgroundColor: bg,
        color: '#fff',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 600,
        fontSize: `${size * 0.4}px`,
        border: '1px solid rgba(255,255,255,0.1)',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
        ...(onClick && { '&:hover': { transform: 'scale(1.05)' } }),
        ...sx,
      }}
    >
      {initial}
    </Avatar>
  );
}
